import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

var _DesignTokens;

const _excluded = ["version", "children", "as", "value", "mode"];
import React, { lazy, Suspense, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import theme, { version as themeVersion, themes } from '@resultadosdigitais/tangram-design-tokens';
import { NAMESPACE } from './constants';
import ThemeContext from './ThemeContext';
import { dependencies as globalDependencies } from '../core/globalHook';
const dependencies = globalDependencies();
const DesignTokens = /*#__PURE__*/lazy(() => import(
/* webpackChunkName: "tangram-design-tokens" */
'../StyleBase/DesignTokens'));

const Theme = _ref => {
  let {
    version,
    children,
    as: Component,
    value: kind,
    mode
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  const formatedVersion = "v".concat(version);
  const [firstDownload, setFirstDownload] = useState();
  useEffect(() => {
    const filtered = dependencies.filter(dep => dep.name === NAMESPACE);
    const notLoaded = !!(filtered.findIndex(dep => dep.version === version) === -1);

    if (notLoaded) {
      dependencies.push({
        name: NAMESPACE,
        version
      });
      setFirstDownload(true);
    } else {
      setFirstDownload(false);
    }
  }, [version]);
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement(Component, _extends({
    "data-tangram-design-tokens": formatedVersion,
    "data-tangram-theme": kind,
    "data-tangram-theme-mode": mode
  }, rest), firstDownload && (_DesignTokens || (_DesignTokens = /*#__PURE__*/React.createElement(DesignTokens, null))), firstDownload !== undefined && /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: {
      tokens: theme(kind, mode),
      version: formatedVersion,
      kind,
      mode
    }
  }, children)));
};

Theme.kinds = themes;
Theme.displayName = 'Theme';
Theme.defaultProps = {
  as: 'div',
  value: Theme.kinds.lina,
  version: themeVersion,
  mode: 'light'
};
process.env.NODE_ENV !== "production" ? Theme.propTypes = {
  /**
   * Sets the children
   */
  children: PropTypes.node,

  /**
   * Sets the element type to be rendered for this component. By default, it will render a `<div>` element.
   */
  as: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),

  /**
   * Sets the theme.
   *
   * `Theme.kinds.crm` and `Theme.kinds.marketing` are **deprecated**.
   */
  value: PropTypes.oneOf([Theme.kinds.lina, Theme.kinds.crm, Theme.kinds.marketing]),

  /**
   * Sets the theme mode.
   */
  mode: PropTypes.string,

  /**
   * @ignore
   */
  version: PropTypes.string
} : void 0;
export default Theme;